import { Component, Vue, Prop } from 'vue-property-decorator'
import AppDateInput from '@core/components/AppDateInput.vue'
import { uniq } from 'lodash/fp'
import TheClientChoiceTR from '@core/components/TheClientChoiceTR.vue'
import RiderProduct from '@master/model/kyc-form/product/RiderProduct'
import InvestmentProduct from '@master/model/kyc-form/product/InvestmentProduct'
import { BasicProductV2 as BasicProduct } from '@master/model/kyc-form/product/BasicProductV2'
import { options } from '@master/model/options/Options'

@Component({
  components: {
    AppDateInput,
    TheClientChoiceTR
  }
})
export class TheClientChoiceTableMixin extends Vue {
  @Prop() rcmds: (BasicProduct | RiderProduct | InvestmentProduct)[]
  @Prop() reviewDate: number
  @Prop() nameList: options[]
  @Prop() customClientChoiceOptions?: Record<string, any>
  @Prop({ default: true }) dateApplicationOn: boolean

  getClientName (product) {
    // it could be combination of Main Account Holder + Joint Account Holder
    // index need to be + 1 because in nameList Array, the 0 index is occupied by empty value
    // the order of nameList is ['', client 1 name, client 2 name, ... dependants names]
    const ownerArray = [this.nameList[product.clientIndex + 1].value]
    if (product.jointClientIndex) {
      ownerArray.push(this.nameList[product.jointClientIndex + 1].value)
    }
    const uniqName = uniq(ownerArray).filter(data => data)
    return uniqName.join(', ')
  }

  getDisabledClientChoice (product) {
    // since all investment subFunds and rider has its own main account/basic product
    // need check on its main account's client choice, if main account has reject/kiv, the subfunds should be disabled
    return (product instanceof RiderProduct || product instanceof InvestmentProduct) ? ['reject', 'kiv'].includes(product.mainProductClientChoice) : false
  }
}
